<template>
  <div class="newsDetail">
    <div class="tips" v-if="show_tips" @click="showTips">此为临时链接，仅用于浏览，将在短期内失效</div>
    <div class="title">{{ articleInfo.title }}</div>
    <div class="list acea-row row-middle">
      <div class="label line1" style="color:#666" @click="goWechar">{{ articleInfo.author }}</div>
      <div class="item">
        <span class="iconfont"></span>{{ articleInfo.add_time }}
      </div>
    </div>
    <div class="conter" v-html="articleInfo.content"></div>
    <div class="picTxt acea-row row-between-wrapper" v-if="storeInfo.id"> 
      <div class="pictrue"><img :src="storeInfo.image" /></div>
      <div class="text">
        <div class="name line1" >{{ storeInfo.store_name }}</div>
        <div class="money font-color-red">
          ￥<span class="num">{{ storeInfo.price }}</span>
        </div>
        <div class="y_money">￥{{ storeInfo.ot_price }}</div>
      </div>
    </div>

    <Leader @confirmCheck="confirmCheck" @cancelCheck="cancelCheck"></Leader>
	<Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<style scoped>
.conter{
  max-width: 100%;
  overflow: hidden;
}
.tips{
  background: #CBDFF6;
  color: #66707C;
  font-size: .24rem;
  line-height: .7rem;
  padding: 0 .26rem;
}
.opt-list{
  position: fixed;
  bottom: 0;
  left: 0;
  height: 1rem;
  width: 100%;
  display: flex;
  margin-top: 2rem;
}
.opt-btn{
  flex: 1;
  text-align: center;
  background: #EEE5C8;
  color: #911D1D;
  font-weight: bold;
  line-height: 1rem;
}
.comment-list{
  padding: 0 .3rem;
  margin-top: 2rem;
}

.comment-list-title{
  line-height: 1rem;
}
.comment-item{
  /* display: flex; */
  border-bottom: 1px solid #f0f0f0;
  padding: .1rem 0;
}
.comment-info{
  display: flex;
  margin-top: .5rem;
}
.reply-item{
  display: flex;
  padding: .5rem .5rem 0;
}
.reply-head img{
  width: .7rem;
  height: .7rem;
  border-radius: .2rem;
  object-fit: cover;
  margin-right: .1rem;
  flex-shrink: 0;
}
.comment-head img{
  width: .9rem;
  height: .9rem;
  border-radius: .2rem;
  object-fit: cover;
  margin-right: .1rem;
  flex-shrink: 0;
}
.comment-member{
  font-size: .28rem;
  line-height: .5rem;
  color: #999;
}
.reply-member{
  font-size: .28rem;
  line-height: .5rem;
  color: #999;
}
.comment-intro{
  font-size: .28rem;
  word-break: break-all;
}
.comment-window{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
  border-radius: .5rem .5rem 0 0;
  padding: 1rem .3rem .5rem;
  z-index: -1;
  opacity: 0;
  transform: translateY(100%);
  transition: .2s;
}
.comment-window.active{
  z-index: 666;
  opacity: 1;
  transform: translateY(0);
  
}
.comment-window .iconfont{
  position: absolute;
  right: .5rem;
  top: .5rem;
  transform: translate(0,-50%);
  border-radius: 50%;
  font-size: .28rem;
}
.comment-textarea{
  height: 2rem;
  padding: .2rem;
  border: 1px solid #f0f0f0;
  border-radius: .3rem;
}
.comment-textarea textarea{
  width: 100%;
  height: 100%;
}
.submit-btn{
  background: #ECE3C6;
  border-radius: 2rem;
  color: #911D1D;
  line-height: .9rem;
  font-size: .32rem;
  text-align: center;
  margin-top: .5rem;
}



.newsDetail .picTxt {
  width: 6.9rem;
  height: 2rem !important;
  border-radius: 0.2rem;
  border: 1px solid #e1e1e1;
  position: relative;
  margin: 0.3rem auto 0 auto;
}
.newsDetail .picTxt .pictrue {
  width: 2rem;
  height: 2rem;
}
.newsDetail .picTxt .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 0.2rem 0 0 0.2rem;
  display: block;
}
.newsDetail .picTxt .text {
  width: 4.6rem;
}
.newsDetail .picTxt .text .name {
  font-size: 0.3rem;
  color: #282828;
}
.newsDetail .picTxt .text .money {
  font-size: 0.24rem;
  margin-top: 0.4rem;
  font-weight: bold;
}
.newsDetail .picTxt .text .money .num {
  font-size: 0.36rem;
}
.newsDetail .picTxt .text .y_money {
  font-size: 0.26rem;
  color: #999;
  text-decoration: line-through;
}
.newsDetail .picTxt .label {
  position: absolute;
  background-color: #303131;
  width: 1.6rem;
  height: 0.5rem;
  right: -0.07rem;
  border-radius: 0.25rem 0 0.06rem 0.25rem;
  text-align: center;
  line-height: 0.5rem;
  bottom: 0.24rem;
}
.newsDetail .picTxt .label.line1{color: #666;}
.newsDetail .picTxt .label .span {
  background-image: linear-gradient(to right, #fff71e 0%, #f9b513 100%);
  background-image: -webkit-linear-gradient(to right, #fff71e 0%, #f9b513 100%);
  background-image: -moz-linear-gradient(to right, #fff71e 0%, #f9b513 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.newsDetail .picTxt .label:after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  border-bottom: 0.08rem solid #303131;
  border-right: 0.08rem solid transparent;
  top: -0.08rem;
  right: 0;
}
.newsDetail .bnt {
  color: #fff;
  font-size: 0.3rem;
  width: 6.9rem;
  height: 0.9rem;
  border-radius: 0.45rem;
  margin: 0.48rem auto 0 auto;
  text-align: center;
  line-height: 0.9rem;
}
.share-btn{
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  line-height: 1rem;
  font-size: .36rem;
  font-weight: bold;
  background: #fff;
}

.new-opt-list{
  position: fixed;
  right: 0;
  bottom: .4rem;
  display: flex;
  flex-direction: column;
}
.new-opt-list img{
  width: 1.58rem;
  height: 1.58rem;
}
</style>
<script>
import { getArticleDetails , Examine} from "@api/public";
import { isWeixin } from "@utils/index";
import Leader from "@/components/Leader.vue";
import Loading from "@components/Loading";
export default {
  name: "NewsDetail",
  props: {},
  components:{Leader,Loading},
  data: function() {
    return {
      articleInfo: {},
      storeInfo: {},
      comment_val:'',
      isWeixin: isWeixin(),
      show_comment:false,
      comment_list:[],
      is_like:0,
      show_tips:false,
	  loaded: false,
	  loading: false,
    };
  },
  watch: {
    $route(to) {
      if (to.name === "NewsDetail"){
        this.articleDetails();
      }
    }
  },
  mounted: function() {
    this.articleDetails();
  },
  methods: {
    confirmCheck(){//主席审核通过
		this.$dialog.loading.open("正在加载中");
		let data={};
		  data.id = this.$route.params.id;
		  data.nav = 0;
		  data.leader_check_status=1;
		Examine(data).then(res => {
			this.$dialog.loading.close();
			this.$dialog.success(res.msg);
			setTimeout(() => {
			  this.$router.go(-1)
			}, 1000);
		}).catch(res=>{
			this.$dialog.loading.close();
			this.$dialog.error(res.msg);
		});
    },
    cancelCheck(e){//主席审核失败
      this.$dialog.loading.open("正在加载中");
      let data={};
        data.id = this.$route.params.id;
        data.nav = 0;
        data.leader_check_status=2;
        data.leader_check_fail_remarks=e;
      Examine(data).then(res => {
      	this.$dialog.loading.close();
      	this.$dialog.success(res.msg);
      	setTimeout(() => {
      	  this.$router.go(-1)
      	}, 1000);
      }).catch(res=>{
      	this.$dialog.loading.close();
      	this.$dialog.error(res.msg);
      });
    },
    goWechar:function(){
      window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI2NDM5MDQ2NQ==&scene=124#wechat_redirect';
    },
    updateTitle() {
      document.title = this.articleInfo.title || this.$route.meta.title;
    },
    articleDetails: function() {
      let that = this,
        id = that.$route.params.id,
        token = this.$route.query.token;
        token = token?token:'';
        if(token) that.showTips();
      getArticleDetails(id,token).then(res => {
        that.articleInfo = res.data;
        that.storeInfo = res.data.store_info || {};
        that.is_like = res.data.is_like;
        that.updateTitle(); 
      }).catch(res=>{
         return this.$dialog.error(
            res.msg
          );
      });
    },
    showTips(){
      this.show_tips = !this.show_tips;
    },
  }
};
</script>
